export default __webpack_public_path__ + "static/media/invoicing.dd4a5f72.png";